import Tooltip from '../../core/components/Tooltip.tsx';
import * as React from 'react';
import { withIcon } from '../../core/components/Icon.tsx';
import { faBuilding, faGearCode } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { ICustomer } from '../../customer/interfaces.ts';
import Popover from '../../core/components/Popover.tsx';
import classnames from '../../core/utils/classnames.tsx';

const CustomizationIcon = withIcon(faGearCode);
const BuildingIcon = withIcon(faBuilding);

const SupportCustomerInfo = ({
    customer,
    isSessionUserOutOfSync,
}: React.ComponentPropsWithRef<'div'> & {
    customer: ICustomer;
    isSessionUserOutOfSync: boolean;
}) => {
    const { t } = useTranslation('support');

    const customizationInfo = customer?.customizationInfo
        ? DOMPurify.sanitize(marked.parse(customer.customizationInfo) as string)
        : null;

    return (
        <Popover open={customizationInfo ? undefined : false}>
            <Popover.Trigger
                className={classnames(
                    'flex text-sm text-content-white dark:text-content-black items-center rounded px-3 py-1 transition-colors bg-surface-transparent',
                    customizationInfo &&
                        'hover:bg-surface-accent-strong-hover data-[state=open]:bg-surface-accent-strong-hover'
                )}
            >
                {!isSessionUserOutOfSync ? (
                    <span className="font-medium flex gap-2 items-center">
                        <BuildingIcon className="text-xs" /> {customer?.name}{' '}
                        {customizationInfo && <CustomizationIcon />}
                    </span>
                ) : (
                    <span className="font-medium">
                        <Tooltip long content={t('supportBar.expiredUserTooltip')}>
                            <span className="flex gap-2">
                                <span className="opacity-50 flex gap-2 items-center">
                                    <BuildingIcon className="text-xs" /> {customer?.name}{' '}
                                    {customizationInfo && <CustomizationIcon />}
                                </span>
                                <span> {t('supportBar.expiredUser')}</span>
                            </span>
                        </Tooltip>
                    </span>
                )}
            </Popover.Trigger>

            <Popover.Content
                dangerouslySetInnerHTML={{ __html: customizationInfo || '' }}
                align="start"
                className="formatted max-w-[40rem] w-full p-6"
            />
        </Popover>
    );
};

export default SupportCustomerInfo;
